import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/siteData";

export default function Hero() {
  return (
    <section className="relative bg-[#1D1F21] text-white overflow-hidden py-16 sm:py-24 lg:py-32 -mt-14 sm:-mt-16 z-0">
      {/* Background Image with High-Contrast Dark Dimming Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/c825601b-4884-4adf-bb6b-b4af6f529bc2/1-syd-facade-efter-640x480-c.jpg"
          alt="Tømrer- og snedkerarbejde i Randers & omegn"
          className="w-full h-full object-cover object-center opacity-85 scale-105"
        />
        {/* Enhanced Dark Gradient Overlays for optimal contrast and atmosphere */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1D1F21] via-[#1D1F21]/80 to-[#1D1F21]/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1D1F21]/60 via-transparent to-[#1D1F21]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl space-y-6 sm:space-y-8">
          
          {/* Main Headline (H1) - Heavy, Bold, Uppercase */}
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-black uppercase text-white tracking-tight leading-tight sm:leading-none">
            Vi tegner jeres drømmebolig og søger de nødvendige tilladelser
          </h1>

          {/* Body Text with Bold White Typography Accents */}
          <p className="text-sm sm:text-base md:text-lg text-gray-200 font-normal leading-relaxed max-w-2xl">
            Hos Kærby Tømrer- & Snedkerforretning ApS leverer vi professionelt tømrer- og snedkerarbejde af højeste kvalitet. Vi udfører <strong className="font-bold text-white">opgaver i hele landet</strong> med stor faglig stolthed, og vi sikrer at alle byggeprojekter afleveres til tiden.
          </p>

          {/* Action CTAs - Pill Variant with Chevrons (») */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2">
            <Link
              to="/ydelser"
              className="inline-flex items-center justify-center gap-2 bg-[#E07A38] hover:bg-[#C96426] text-white font-bold text-xs sm:text-sm uppercase tracking-wider px-8 py-4 rounded-md shadow-lg transition-all transform hover:scale-[1.02]"
            >
              <span>Se vores arbejdsområder</span>
              <span className="text-white font-black tracking-tighter text-base leading-none">»</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-[#272A2E] hover:bg-zinc-700 border border-zinc-700 text-white font-bold text-xs sm:text-sm uppercase tracking-wider px-8 py-4 rounded-md shadow-md transition-all text-center"
            >
              <span>Få et uforpligtende tilbud</span>
              <span className="text-[#E07A38] font-black tracking-tighter text-base leading-none">»</span>
            </Link>
          </div>

          {/* Key Selling Points Grid */}
          <div className="pt-8 border-t border-zinc-800 grid grid-cols-2 sm:grid-cols-3 gap-6 text-xs font-bold uppercase tracking-wider text-stone-300">
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-circle-check text-[#E07A38] text-base shrink-0" aria-hidden="true" />
              <span>Garanti for kvalitet</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-clock text-[#E07A38] text-base shrink-0" aria-hidden="true" />
              <span>Aftaler overholdes</span>
            </div>
            <div className="flex items-center gap-3 col-span-2 sm:col-span-1">
              <i className="fa-solid fa-compass-drafting text-[#E07A38] text-base shrink-0" aria-hidden="true" />
              <span>Tømrer & Snedker</span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
